/* Sacred Sin -- Page transition: Curtain + Stagger Words */
(function () {

  /* ── Curtain ─────────────────────────────────────────────────── */
  var lp = document.querySelector('.ss-curtain-left');
  var rp = document.querySelector('.ss-curtain-right');
  var logo = document.querySelector('.ss-curtain-logo');
  var CURTAIN_MS = 750;

  function openCurtain() {
    if (!lp) return;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        lp.classList.add('is-open');
        rp.classList.add('is-open');
        if (logo) logo.classList.add('is-open');
      });
    });
  }

  function closeCurtain(done) {
    if (!lp) { done && setTimeout(done, 0); return; }
    lp.classList.remove('is-open');
    rp.classList.remove('is-open');
    if (logo) logo.classList.remove('is-open');
    if (done) setTimeout(done, CURTAIN_MS);
  }

  /* Open on every page load */
  openCurtain();

  /* bfcache: when user swipes back, force curtain open so it doesn't stay stuck */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) openCurtain();
  });

  /* Close curtain then navigate on internal link clicks */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href]');
    if (!a) return;
    var href = a.getAttribute('href');
    if (!href
        || href[0] === '#'
        || href.startsWith('mailto:')
        || href.startsWith('tel:')
        || href.startsWith('javascript:')) return;
    if (a.target === '_blank'
        || a.hasAttribute('download')
        || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    try {
      if (new URL(href, location.origin).origin !== location.origin) return;
    } catch (_) { return; }

    e.preventDefault();
    closeCurtain(function () { window.location.href = href; });
  }, true);

  /* ── Stagger Words ───────────────────────────────────────────── */
  var WORD_SELECTORS = [
    '.ss-collection__title',
    '.ss-related-drops__heading',
    '.ss-origin-band__text',
  ].join(',');

  function splitWords(el, delay) {
    if (el.dataset.ssWordSplit) return;
    el.dataset.ssWordSplit = '1';
    delay = delay || 100;

    /* Remove ss-reveal to avoid double animation */
    el.classList.remove('ss-reveal');
    el.style.opacity = '';
    el.style.transform = '';

    var text = el.textContent.trim();
    if (!text) return;

    el.innerHTML = text.split(/\s+/).map(function (w, i) {
      return '<span class="ss-word">'
           + '<span class="ss-word__inner" style="transition-delay:' + (i * delay) + 'ms">'
           + w
           + '</span></span>';
    }).join(' ');
  }

  function revealWords() {
    document.querySelectorAll('.ss-word__inner:not(.is-visible)').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  function initWords() {
    document.querySelectorAll(WORD_SELECTORS).forEach(splitWords);
    /* Start revealing words as curtain nears fully open (~500ms in) */
    setTimeout(revealWords, 480);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWords);
  } else {
    initWords();
  }

  /* ── Scroll-reveal words ─────────────────────────────────────── */
  function initScrollWords() {
    /* Mark richtext paragraph children as scroll-reveal targets */
    document.querySelectorAll('[data-ss-scroll-words-parent] p').forEach(function (p) {
      p.classList.add('ss-scroll-words');
    });

    var scrollEls = document.querySelectorAll('.ss-scroll-words');
    if (!scrollEls.length || !window.IntersectionObserver) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        io.unobserve(el);
        splitWords(el, 50);
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            el.querySelectorAll('.ss-word__inner').forEach(function (inner) {
              inner.classList.add('is-visible');
            });
          });
        });
      });
    }, { threshold: 0, rootMargin: '0px 0px 120px 0px' });

    scrollEls.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollWords);
  } else {
    initScrollWords();
  }

})();

/* ── Active nav highlight ────────────────────────────────────── */
(function () {
  var path = window.location.pathname.replace(/\/$/, '') || '/';
  var links = document.querySelectorAll('.horizontal-list.level0 > li > menu-item > a');
  links.forEach(function (a) {
    var href = a.getAttribute('href') || '';
    var linkPath = href.replace(/\/$/, '') || '/';
    if (path === linkPath || (linkPath !== '/' && path.indexOf(linkPath) === 0)) {
      a.setAttribute('aria-current', 'page');
    }
  });
})();
